import { render, staticRenderFns } from "./global-case.vue?vue&type=template&id=54c61b18&scoped=true&"
import script from "./global-case.vue?vue&type=script&lang=js&"
export * from "./global-case.vue?vue&type=script&lang=js&"
import style0 from "./global-case.vue?vue&type=style&index=0&id=54c61b18&prod&scoped=true&lang=less&"
import style1 from "./global-case.vue?vue&type=style&index=1&id=54c61b18&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c61b18",
  null
  
)

export default component.exports